import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DepositoEfectivoService } from 'src/app/services/deposito-efectivo.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'
import { ToastService } from 'ng-uikit-pro-standard';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-timbrar-deposito-efectivo',
  templateUrl: './timbrar-deposito-efectivo.component.html',
  styleUrls: ['./timbrar-deposito-efectivo.component.scss'],
  providers: [SecurityService]
})
export class TimbrarDepositoEfectivoComponent implements OnInit {

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  listaDepositos: any = null
  paginationContext: PaginationContext = new PaginationContext()

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private depositoEfectivoService: DepositoEfectivoService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private rutService: RutService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('TIMBRAR-DEPOSITO-EFECTIVO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10

    this.createForm()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
    });
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaDepositos = null
    const inputParams = {
      entidad: {
        empresa_rut: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.depositoEfectivoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      let ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaDepositos = registros
      this.listaDepositos.forEach((deposito, index) => {
        deposito.seleccion = false
        deposito.index = index

        delete deposito.__typename

        deposito.depositanteRutFormato = this.rutService.AgregarDV(deposito.depositante_rut)
      });
    })
  }

  onPageChange(context: PaginationContext) {
    this.log('onPageChange', context)
    this.buscar(context.RequestedPage)
  }

  checkAllChange({ checked }) {
    this.listaDepositos.forEach(detalle => { detalle.seleccion = checked })
  }

  checkDetalle({ index }) {
    const selected = this.listaDepositos.filter(p => p.index === index)[0]
    selected.seleccion = !selected.seleccion
  }

  timbrar() {
    let lista = _.cloneDeep(this.listaDepositos)
    lista = lista.filter(deposito => deposito.seleccion)
    if (lista.length === 0) {
      this.toastService.warning('Seleccione un depósito')
      return
    }

    lista.forEach(deposito => {
      delete deposito.index
      delete deposito.depositanteRutFormato
    });

    const inputParams = {
      entidad: {
        lista
      }
    }

    this.log(JSON.stringify(inputParams))

    this.depositoEfectivoService.timbradoDepositoEfectivo(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastService.success('Operación realizada')
      this.buscar(1)
    })
  }

}
